import { render, staticRenderFns } from "./txtEvidence.vue?vue&type=template&id=04de11e0&scoped=true"
import script from "./txtEvidence.vue?vue&type=script&lang=js"
export * from "./txtEvidence.vue?vue&type=script&lang=js"
import style0 from "./txtEvidence.vue?vue&type=style&index=0&id=04de11e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de11e0",
  null
  
)

export default component.exports